import * as React from 'react';
import { Box, Card, CircularProgress, Typography } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import {
    TextInput, useDataProvider,
    Form, Button, useNotify, useTranslate, useLogin, useRedirect, PasswordInput
} from 'react-admin';

// 引入本地图片（根据实际路径调整）
import login_bg_1 from '../static/login_bg_1.png';
import login_bg_2 from '../static/login_bg_2.png';
import login_bg_3 from '../static/login_bg_3.png';
import icon from '../static/icon.png'; // 添加图标的导入
import { useEffect, useState } from 'react';

const MyLoginPage = (props: any) => {
    const { redirectTo } = props;
    const redirect = useRedirect(); // 添加重定向钩子
    const dataProvider = useDataProvider(); // 获取dataProvider
    const login = useLogin();
    const [captchaData, setCaptchaData] = useState<{
        image: string;
        tokenId: string
    }>({ image: '', tokenId: '' });

    const translate = useTranslate();
    const [loading, setLoading] = useState(false);

    function generateUUID() {
        return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
            (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
        );
    }

    // 获取验证码
    const fetchCaptcha = async () => {
        try {
            // 如果已经有tokenId，使用现有值；否则使用默认值

            const tokenId = generateUUID();
            dataProvider.getCaptcha({ tokenId }).then(res => {
                console.log(res)
                if (!res.tokenId) {
                    notify("获取验证码操作频繁，请1分钟后再试，谢谢！", { type: "error" });
                }
                setCaptchaData({
                    image: res.imageUrl,
                    tokenId: res.tokenId // 使用接口返回的新tokenId
                });
            }).catch(err => {
                console.log(err)
            });
        } catch (error) {
            console.error('获取验证码失败:', error);
        }
    };

    const notify = useNotify();
    const submit = (auth: any) => {
        // if (!auth.username) {
        //     notify("用户名不能为空", { type: "error" });
        //     return
        // }

        setLoading(true);

        login({
            username: auth.username,
            password: auth.password,
            captcha: auth.captcha,
            tokenId: captchaData.tokenId // 添加tokenId参数
        }, redirectTo)
            .then(() => {
                setLoading(false);
                redirect('/', { replace: true });
            })
            .catch(error => {
                setLoading(false);
                console.log('error-----', error)
                notify(
                    typeof error === 'string'
                        ? error
                        : typeof error === 'undefined' || !error.message
                            ? 'ra.auth.sign_in_error'
                            : error.message,
                    {
                        type: 'error',
                        messageArgs: {
                            _:
                                typeof error === 'string'
                                    ? error
                                    : error && error.message
                                        ? error.message
                                        : undefined,
                        },
                    }
                );
            });
    };

    // 组件加载时获取验证码
    useEffect(() => {
        fetchCaptcha();
    }, []);



    return (
        <Box
            sx={{
                backgroundColor: '#037ff2',
                position: 'relative',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                boxSizing: 'border-box',
                backgroundImage: `url(${login_bg_1})`,
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                height: '100%',
            }}
        >
            <Box
                sx={{
                    position: 'absolute',
                    bottom: 0,
                    boxSizing: 'border-box',
                    backgroundImage: `url(${login_bg_2})`,
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'cover',
                    width: '100vw',
                    height: '300px',
                }}
            />
            <Box sx={{
                position: 'fixed',
                top: 0,
                backgroundColor: 'rgba(0, 0, 0, 0.3)',
                display: 'flex',
                justifyContent: 'space-between',
                width: '100%',
                padding: '10px',
            }}>
                <div style={{ display: 'flex' }}>
                    {/* <Box
                        sx={{
                            position: 'absolute',
                            bottom: 0,
                            boxSizing: 'border-box',
                            backgroundImage: `url(${icon})`,
                            backgroundRepeat: 'no-repeat',
                            backgroundSize: 'cover',
                            width: '100vw',
                            height: '300px',
                        }}
                    /> */}
                    <img
                        src={icon}
                        alt="公司图标"
                        style={{
                            height: '40px',
                            marginRight: '20px'
                        }}
                    />
                    <Typography variant="h5" sx={{
                        fontSize: { lg: '1.5rem', xs: '12px' },
                        color: "white",
                    }}>深圳长嘉科豪数字技术有限公司</Typography>
                </div>
                <Box sx={{
                    display: 'flex',
                }}>
                    <Typography variant="h5" sx={{
                        fontSize: { lg: '1.5rem', xs: '12px' },
                        color: "white",
                    }}>欢迎登录</Typography>
                    <Box sx={{
                        height: '100%',
                        margin: "0px 10px",
                        width: '2px',
                        backgroundColor: 'white',
                    }}></Box>
                    <Typography variant="h5" sx={{ fontSize: { lg: '1.5rem', xs: '12px' }, color: "white", fontWeight: '300' }}>边缘计算客户管理平台</Typography>
                </Box>
            </Box>
            <Box sx={{
                position: 'fixed',
                bottom: 0,
                backgroundColor: 'rgba(0, 0, 0, 0.3)',
                display: 'flex',
                justifyContent: 'center',
                width: '100%',
                padding: '10px',
            }}>
                <Typography variant="body2" color="textSecondary" sx={{
                    color: "white",
                }}>Copyright 2023-2024 深圳长嘉科豪数字技术有限公司 All Rights Reserved.</Typography>
            </Box>

            {/* 登录表单容器 */}
            <Box sx={{
                position: 'relative',
                display: 'flex',
                alignItems: 'center',
                maxWidth: '100%',
                overflow: { lg: 'auto', xs: 'hidden' }
            }}>
                <Box sx={{
                    backgroundColor: '#ffffff',
                    display: 'flex',
                    flexDirection: 'column',
                    position: 'absolute',
                    alignItems: 'end',
                    padding: '40px 20px',
                    left: '500px',
                    width: '330px',
                    borderRadius: '20px',
                }}>
                    <Typography sx={{ color: 'black', fontWeight: 'bold', fontSize: '20px' }}>边缘计算客户管理平台</Typography>
                    <Typography sx={{ color: 'rgb(102, 102, 102)', fontSize: '16px' }}>V1.0.0</Typography>
                    <Box
                        sx={{
                            backgroundImage: `url(${login_bg_3})`,
                            backgroundRepeat: 'no-repeat',
                            backgroundSize: 'cover',
                            width: '276px',
                            height: '236px',
                        }}
                    />
                </Box>
                <Card sx={{
                    backgroundColor: "#111D32",
                    position: 'relative',
                    marginRight: { lg: '300px', xs: '0px' },
                    borderRadius: '20px',
                    padding: '40px',
                    width: '530px',
                }}>
                    <Form onSubmit={submit}>
                        <Box sx={{
                            width: '100px',
                            height: '100px',
                            borderRadius: '50%',
                            position: 'relative',
                            margin: '0 auto 10px',
                            backgroundColor: 'white'
                        }}><PersonIcon sx={{
                            width: 100,
                            height: 100,
                        }} /></Box>

                        <TextInput source="username" label="账号" sx={{
                            // 标签文字颜色
                            '& label': {
                                color: '#1976d2 !important',
                            },
                            // 输入文字颜色改为黑色
                            '& .MuiInputBase-input': {
                                color: '#000000' // 黑色文字
                            },
                        }}
                            InputProps={{
                                sx: {
                                    backgroundColor: 'rgb(232, 240, 254) !important',
                                    '&:before': {
                                        borderBottom: '2px solid #1976d2 !important'
                                    }
                                }
                            }} />
                        <PasswordInput source="password" label="密码" sx={{
                            // 标签文字颜色
                            '& label': {
                                color: '#1976d2 !important',
                            },
                            // 输入文字颜色改为黑色
                            '& .MuiInputBase-input': {
                                color: '#000000' // 黑色文字
                            },
                            '& .MuiFilledInput-root': {
                                backgroundColor: 'rgb(232, 240, 254) !important',
                            },
                            '&:before': {
                                borderBottom: '2px solid #1976d2 !important'
                            },
                        }} />
                        <Box sx={{
                            display: 'flex',
                            gap: '10px',
                            cursor: 'pointer',
                        }}>
                            <TextInput source="captcha" label="验证码" sx={{
                                // 标签文字颜色
                                '& label': {
                                    color: '#1976d2 !important',
                                },
                                // 输入文字颜色改为黑色
                                '& .MuiInputBase-input': {
                                    color: '#000000' // 黑色文字
                                },
                            }}
                                InputProps={{
                                    sx: {
                                        backgroundColor: 'rgb(232, 240, 254) !important',
                                        '&:before': {
                                            borderBottom: '2px solid #1976d2 !important'
                                        }
                                    }
                                }} />
                            <Box sx={{
                                position: 'relative',
                            }} onClick={fetchCaptcha}>
                                <img
                                    src={captchaData.image || null}
                                    alt="验证码"
                                    style={{
                                        height: '48px',
                                        marginTop: '8px'
                                    }}
                                />
                            </Box>
                        </Box>
                        <Button
                            variant="contained"
                            type="submit"
                            color="primary"
                            disabled={loading}
                            fullWidth
                            sx={{ height: '48px' }}
                            className={'RaLoginForm-button'}
                        >
                            {loading ? (
                                <CircularProgress
                                    className={'RaLoginForm-icon'}
                                    size={19}
                                    thickness={3}
                                />
                            ) : (
                                translate('ra.auth.sign_in')
                            )}
                        </Button>
                    </Form>
                </Card>
            </Box>
        </Box >
    )
};

export default MyLoginPage;